/* eslint-disable func-style */
import { useFetch2 } from "../util";

export type AttendantProductivity = {
  userId: number | null;
  name: string;
  active: boolean;
  system: boolean;
  inProgress: number | null;
  closed: number;
  assumed: number | null;
  transferred: number | null;
  closingRate: number | null;
};

export type AttendantsProductivityResponse = {
  summary: {
    activeAttendants: number;
    closedInPeriod: number;
    inProgressNow: number;
    averageClosedPerAttendant: number | null;
  };
  attendants: AttendantProductivity[];
};

export type DashboardAttendantOption = {
  id: number;
  name: string;
  active: boolean;
};

function DashboardServices() {
  const useQuery = useFetch2();
  type getDashboardType = {
    bots: number[];
    endAt: string; // format Date 2023-04-01
    startAt: string; // format Date 2023-04-01
  };
  type getDashboardByHour = {
    bots: number[];
    day: string; // format Date 2023-04-01
  };
  type getAttendantsProductivityType = {
    bots: number[];
    startAt: string; // format Date 2023-04-01
    endAt: string; // format Date 2023-04-01
    users: number[]; // vazio = todos os atendentes
  };
  // this code just return a promise function to who is calling a function.
  // const getDashboardByDates = (input: getDashboardType) => {
  //   const params = new URLSearchParams();
  //   params.append(
  //     "startAt",
  //     `${input.startAt || new Date().toISOString().substring(0, 10)}`
  //   );
  //   params.append(
  //     "endAt",
  //     `${input.endAt || new Date().toISOString().substring(0, 10)}`
  //   );
  //   if (input.bots?.length) {
  //     input.bots.map((el) => params.append("bots", String(el)));
  //   } else {
  //     params.append("bots", "0");
  //   }
  //   return useQuery(`/api/dashboard/{info}?${params}`, { method: "GET" });
  // };
  const getDashboardByDates = <R = unknown>(input: getDashboardType) => {
    // const params = new URLSearchParams();
    // params.append(
    //   "startAt",
    //   `${input.startAt || new Date().toISOString().substring(0, 10)}`
    // );
    // params.append(
    //   "endAt",
    //   `${input.endAt || new Date().toISOString().substring(0, 10)}`
    // );
    // if (input.bots?.length) {
    //   input.bots.map((el) => params.append("bots", String(el)));
    // } else {
    //   params.append("bots", "0");
    // }
    return useQuery<R>(`/api/dashboard/{info}`, { method: "POST" }, { ...input });
  };
  const getDashboardByHours = async <R = unknown>(
    input: getDashboardByHour
  ): Promise<R | undefined> => {
    const params = new URLSearchParams();
    if (input.bots?.length) {
      input.bots.map((el) => params.append("bots", String(el)));
    } else {
      params.append("bots", "0");
    }
    params.append(
      "day",
      `${input.day || new Date().toISOString().substring(0, 10)}`
    );
    try {
      const method = { method: "GET" };
      return await useQuery<R>(
        `/api/dashboard/services-by-hour?${params}`,
        method
      );
    } catch (error) {
      // useFetch2 já exibe o toast de erro
      return undefined;
    }
  };

  const getAttendantsProductivity = <R = AttendantsProductivityResponse>(
    input: getAttendantsProductivityType
  ) =>
    useQuery<R>(
      `/api/dashboard/attendants-productivity`,
      { method: "POST" },
      { ...input }
    );
  const getDashboardAttendants = <R = DashboardAttendantOption[]>(input: {
    bots: number[];
  }) =>
    useQuery<R>(`/api/dashboard/attendants`, { method: "POST" }, { ...input });

  return {
    getDashboardByDates,
    getDashboardByHours,
    getAttendantsProductivity,
    getDashboardAttendants
  };
}

export default DashboardServices;
